<template>
  <div class="gift-popup">
    <div class="gift-popup-bg" v-on:click="close"></div>
    <div class="gift-popup-get j-gift-popup" v-show="popupType=='successPop'">
      <div class="gift-popup-pic"></div>
      <div class="gift-popup-content">
        <button class="gift-popup-cancle" v-on:click="close"></button>
        <h3 class="gift-popup-content-title">恭喜您領到禮包</h3>
        <div class="gift-popup-content-gift">
          <span class="gift-popup-content-gift-title">禮包內容：</span>
          <span class="gift-popup-content-gift-content">{{giftInfo.content}}</span>
        </div>
        <p class="gift-popup-content-box">
          <span class="gift-popup-content-num">{{giftInfo.card}}</span>
          <input type="text" name class="copy-input" id="j-gift-num" v-model="giftInfo.card" />
          <button class="gift-popup-content-copy" data-clipboard-target="#j-gift-num">{{copyText}}</button>
        </p>
        <div class="gift-popup-content-tipbox">
          <span class="gift-popup-content-other">兌換方式</span>
          <p class="gift-popup-content-tips">
            <a
              class="reard-url"
              target="blank"
              href="//events.gm99.com/static/html/gm_platform/gmexchange/index.html"
            >請複製禮包序號，並前往【序號兌換頁】處領用</a>
          </p>
        </div>
      </div>
    </div>
    <div class="gift-popup-unget j-gift-popup" v-show="popupType=='failGiftPop'">
      <button class="gift-popup-cancle" v-on:click="close"></button>
      <div class="gift-popup-unget-pic"></div>
    </div>
    <div class="gift-popup-unget j-gift-popup" v-show="popupType=='failCheckPop'">
      <button class="gift-popup-cancle" v-on:click="close"></button>
      <div class="gift-popup-unget-bg">
        <span class="gift-popup-unget-text">{{errMsg}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import clipboard from "clipboard";
import { bus } from "../utile";
import giftStore from "../store/gift";

export default {
  data() {
    return {
      copyText: "複 製",
    };
  },
  methods: {
    close() {
      this.$emit("closeGiftPopup");
      this.copyText = "複 製";
    },
    copyResult() {
      this.copyText = "複製成功";
      //this.$emit("copySuccess");
    },
  },
  computed: {
    popupType() {
      return giftStore.state.getGiftSuccess;
    },
    giftInfo() {
      return giftStore.state.giftInfo;
    },
    errMsg() {
      return giftStore.state.errmsg;
    },
  },
  name: "Gift",
  mounted() {
    const clipboards = new clipboard(".gift-popup-content-copy");
    clipboards.on("success", this.copyResult.bind(this));
    clipboards.on("error", (e) => {
      console.log(e);
    });
  },
};
</script>


<style lang="scss">
$divide: 10 !default;
$pswWidth: 640;

$imgURL: "../assets/img/";
.gift-popup {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 100;
  top: 0;
  bottom: 0;
  &-bg {
    background-color: black;
    opacity: 0.6;
    z-index: -1;
    width: 100%;
    height: 100%;
    position: fixed;
    cursor: pointer;
  }
  &-pic {
    background: url($imgURL + "h5.png") no-repeat top center;
    background-size: contain;
    width: 258px;
    height: 267px;
    margin: auto;
  }
  &-get {
    position: absolute;
    top: 40%;
    left: 50%;
    width: 537px;
    height: 688px;
    margin-left: -268px;
    margin-top: -344px;
  }
  &-content {
    width: 537px;
    height: 421px;
    border-radius: 6px;
    border: 1px solid #f87e19;
    background-color: white;
    margin: auto;
    text-align: center;
    &-title {
      color: #666;
      font-size: 32px;
      text-align: center;
      margin: 40px auto 36px;
    }
    &-gift {
      font-size: 22px;
      color: #f87e19;
      margin: auto 10px;
      text-align: left;
      &-title {
        float: left;
        display: table;
        line-height: 30px;
      }
      &-content {
        display: table;
        line-height: 30px;
      }
    }
    &-box {
      display: flex;
      margin-top: 35px;
      width: 100%;
      input {
        opacity: 0;
        position: absolute;
      }
    }
    &-num {
      height: 65px;
      line-height: 65px;
      background-color: #e5e5e5;
      padding: 0 18px;
      font-size: 28px;
      color: #f87e19;
      width: 373px;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: block;
      float: left;
    }
    &-copy {
      border-radius: 0;
      height: 65px;
      line-height: 65px;
      background-color: #f87e19;
      color: white;
      width: 160px;
      font-size: 28px;
    }
    &-tipbox {
      border-top: 1px solid #e5e5e5;
      margin: 22px 20px auto;
    }
    &-other {
      font-size: 20px;
      color: #0e7fe9;
      margin-bottom: 15px;
      position: relative;
      left: 0;
      right: 0;
      top: -12px;
      margin: auto;
      background-color: white;
      padding: 0 20px;
    }
    &-tips {
      font-size: 18px;
      color: #aaa;
      line-height: 30px;
      text-align: left;
    }
  }
  &-cancle {
    background: none;
    border: none;
    background-image: url($imgURL + "x.png");
    background-size: 100% 100%;
    width: 57px;
    height: 57px;
    position: absolute;
    right: 20px;
    top: 40px;
    z-index: 100;
    padding: 0;
  }
  &-unget {
    position: absolute;
    top: 40%;
    left: 50%;
    width: 453px;
    height: 220px;
    margin-left: -226px;
    margin-top: -110px;
    .gift-popup-cancle {
      top: 0;
      right: 0;
      z-index: 100;
    }
    &-pic {
      background: url($imgURL + "gift_over.png") no-repeat top center;
      background-size: contain;
      width: 453px;
      height: 220px;
      margin: auto;
    }
    &-bg {
      background: url($imgURL + "gift-popup.png") no-repeat top center;
      background-size: contain;
      width: 453px;
      height: 220px;
      margin: auto;
      text-align: center;
    }
    &-text {
      position: absolute;
      font-size: 28px;
      color: #f87e19;
      width: 200px;
      display: block;
      top: 110px;
      right: 150px;
      line-height: 30px;
    }
  }
}
.reard-url {
  color: #0e7fe9;
}
</style>


// WEBPACK FOOTER //
// src/components/GiftPopup.vue